import { render, staticRenderFns } from "./ReportViewer.vue?vue&type=template&id=bfb6b8c2"
import script from "./ReportViewer.vue?vue&type=script&lang=js"
export * from "./ReportViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports